import axiosInstance from './api';

export const fetchCurrentUser = async (token) => {
  try {
    const response = await axiosInstance.get('/me', {
      headers: { Authorization: `Bearer ${token}` },
    });
    console.log('Fetch current user response:', response.data);
    return response.data;
  } catch (err) {
    console.error('Fetch current user error:', {
      status: err.response?.status,
      data: err.response?.data,
      message: err.message,
    });
    throw err;
  }
};

export const createInvite = async (token) => {
  try {
    const response = await axiosInstance.post('/invites', {}, {
      headers: { Authorization: `Bearer ${token}` },
    });
    console.log('Create invite response:', response.data);
    return response.data;
  } catch (err) {
    console.error('Create invite error:', {
      status: err.response?.status,
      data: err.response?.data,
      message: err.message,
    });
    throw err;
  }
};

export const fetchInvites = async (token) => {
  try {
    const response = await axiosInstance.get('/invites', {
      headers: { Authorization: `Bearer ${token}` },
    });
    console.log('Fetch invites response:', response.data);
    return response.data;
  } catch (err) {
    console.error('Fetch invites error:', {
      status: err.response?.status,
      data: err.response?.data,
      message: err.message,
    });
    throw err;
  }
};

export const fetchUsers = async (token) => {
  try {
    const response = await axiosInstance.get('/users', {
      headers: { Authorization: `Bearer ${token}` },
    });
    console.log('Fetch users response:', response.data);
    return response.data;
  } catch (err) {
    console.error('Fetch users error:', {
      status: err.response?.status,
      data: err.response?.data,
      message: err.message,
    });
    throw err;
  }
};

export const generateResetPasswordLink = async (userId, token) => {
  try {
    const response = await axiosInstance.post(`/users/${userId}/reset-password`, {}, {
      headers: { Authorization: `Bearer ${token}` },
    });
    console.log('Generate reset password response:', response.data);
    return response.data;
  } catch (err) {
    console.error('Generate reset password error:', {
      status: err.response?.status,
      data: err.response?.data,
      message: err.message,
    });
    throw err;
  }
};

export const toggleUserActive = async (userId, token) => {
  try {
    const response = await axiosInstance.patch(`/users/${userId}/toggle-active`, {}, {
      headers: { Authorization: `Bearer ${token}` },
    });
    console.log('Toggle user active response:', response.data);
    return response.data;
  } catch (err) {
    console.error('Toggle user active error:', {
      status: err.response?.status,
      data: err.response?.data,
      message: err.message,
    });
    throw err;
  }
};

export const refreshAccessToken = async (refreshToken) => {
  try {
    const response = await axiosInstance.post('/auth/refresh', { refresh_token: refreshToken });
    console.log('Refresh token response:', response.data);
    return response.data;
  } catch (err) {
    console.error('Refresh token error:', {
      status: err.response?.status,
      data: err.response?.data,
      message: err.message,
    });
    throw err;
  }
};

export const updateUser = async (userId, userData, token) => {
  try {
    const response = await axiosInstance.put(`/users/${userId}`, userData, {
      headers: { Authorization: `Bearer ${token}` },
    });
    console.log('Update user response:', response.data);
    return response.data;
  } catch (err) {
    console.error('Update user error:', {
      status: err.response?.status,
      data: err.response?.data,
      message: err.message,
    });
    throw err;
  }
};